/**
 * lagerNavState — hält die Navigations-Position des Lager-Moduls über
 * LagerShell-Unmounts hinweg (z. B. Lager → Schnell-BANF → Warenkorb → Zurück),
 * damit der User wieder an derselben Stelle landet (Sektion, Werk, offener Artikel).
 *
 * Bewusst modul-global (kein Prop-Threading über 4 Ebenen). Session-scoped:
 * wird bei einem echten Page-Reload zurückgesetzt. Beim normalen Verlassen des
 * Moduls (Home) bleiben die Werte erhalten und stellen die letzte Position wieder her.
 */
const lagerNavState = {
  activeSection: 'dashboard',
  selectedWerk: '',
  expandedMatnr: null,
};

export default lagerNavState;
